export default __webpack_public_path__ + "static/media/BAN1.ef617e48.jpg";